import React from 'react'
import PropTypes from 'prop-types'

import GeneralCreateEventButton from './general_create_event_button'

const ManageGroupsButton = ({ manageGroupsURL, managedGroups, userIsGroupLeader }) => {
  const i18nKey = userIsGroupLeader && managedGroups.length === 1
    ? 'customer_center_comp.components.action_buttons.manage_groups_button.manage_group'
    : 'customer_center_comp.components.action_buttons.manage_groups_button.manage_groups'
  const actionDescription = (!window.I18n ? '' : window.I18n.t('customer_center_comp.components.action_buttons.manage_groups_button.manage_groups_description'))
  return (
    <GeneralCreateEventButton
      actionName={ !window.I18n ? '' : window.I18n.t(i18nKey) }
      actionDescription={ userIsGroupLeader ? '' : actionDescription}
      iconSrc={ require('manage_groups.svg') }
      openPopup={ () => { window.location.href = manageGroupsURL } }
      disabled={ false }
      extraMargin={ true }
    />
  )
}

ManageGroupsButton.propTypes = {
  manageGroupsURL: PropTypes.string.isRequired,
  managedGroups: PropTypes.array.isRequired,
  userIsGroupLeader: PropTypes.bool.isRequired,
}

export default ManageGroupsButton
